<app-header></app-header>
<div class="container">
    <div class="storiesbox mt-5">
        <h2>Explore Categories</h2>
        <!-- Swiper Container -->
        <div class="allCat">
            <div class="row">
                <div class="col-sm-3">
                    <div class="col-sm-12 catBox">
                        <div class="catImg">
                            <img src="cover.jpeg" alt="">
                        </div>
                        <div class="catDetails">
                            <h5>Horror Story</h5>
                        </div>

                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="col-sm-12 catBox">
                        <div class="catImg">
                            <img src="cover.jpeg" alt="">
                        </div>
                        <div class="catDetails">
                            <h5>Horror Story</h5>
                        </div>

                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="col-sm-12 catBox">
                        <div class="catImg">
                            <img src="cover.jpeg" alt="">
                        </div>
                        <div class="catDetails">
                            <h5>Horror Story</h5>
                        </div>

                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="col-sm-12 catBox">
                        <div class="catImg">
                            <img src="cover.jpeg" alt="">
                        </div>
                        <div class="catDetails">
                            <h5>Horror Story</h5>
                        </div>

                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="col-sm-12 catBox">
                        <div class="catImg">
                            <img src="cover.jpeg" alt="">
                        </div>
                        <div class="catDetails">
                            <h5>Horror Story</h5>
                        </div>

                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="col-sm-12 catBox">
                        <div class="catImg">
                            <img src="cover.jpeg" alt="">
                        </div>
                        <div class="catDetails">
                            <h5>Horror Story</h5>
                        </div>

                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="col-sm-12 catBox">
                        <div class="catImg">
                            <img src="cover.jpeg" alt="">
                        </div>
                        <div class="catDetails">
                            <h5>Horror Story</h5>
                        </div>

                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="col-sm-12 catBox">
                        <div class="catImg">
                            <img src="cover.jpeg" alt="">
                        </div>
                        <div class="catDetails">
                            <h5>Horror Story</h5>
                        </div>

                    </div>
                </div>
            </div>
           
        </div>
    </div>
</div>